import React from "react";
import { PercentageIncreaseDonutChartTemplate } from "themes/administration/analytics/components";

function PercentageIncreaseDonutChart(props) {
    return <PercentageIncreaseDonutChartTemplate {...props} />;
}

export default PercentageIncreaseDonutChart;
